import PropTypes from 'prop-types'

import {Dialog, styled} from '@mui/material'

import Closer from '../../../core/closer/Closer'

const StyledDialog = styled(Dialog)(
  () => `
    .accessible-small-modal-paper {
      border-radius: 20px;
      display: flex;
      flex-direction: column;
      margin: 16px;
      max-width: 480px;
      padding: 32px;
      position: relative;
      width: 100%;
    }

    .accessible-small-modal-paper .core.closer {
      right: 14px;
      top: 14px;
    }
  `
)

const StyledAccessibleSmallModal = ({
  children,
  closerLabel = 'Close modal',
  labelledBy,
  onClose,
  open,
  showCloser = true,
  ...otherProps
}) => (
  <StyledDialog
    {...otherProps}
    aria-labelledby={labelledBy}
    data-testid='accessible-small-modal'
    onClose={onClose}
    open={open}
    PaperProps={{className: 'accessible-small-modal-paper'}}>
    {
      showCloser &&
      <Closer alt={closerLabel} className='accessible-small-modal-closer' closer={onClose} />
    }
    {children}
  </StyledDialog>
)

StyledAccessibleSmallModal.propTypes = {
  children: PropTypes.node.isRequired,
  closerLabel: PropTypes.string,
  labelledBy: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  showCloser: PropTypes.bool
}

export default StyledAccessibleSmallModal
